<div *ngIf="!otaOtdData" class="main">
    <div class="heading d-flex flex-dir-row just-space">
        <div class="d-flex flex-dir-col">
            <div class="d-flex just-space"><span class="h6-b">{{stopDetail.address}}</span><img *ngIf="false"
                    class="pointer-cursor" (click)="onClosePopup()" src="{{imgSrc}}assets/icons/cross-icon.svg" alt="">
            </div>
            <div class="d-flex gap-8" >
                <span class="h8 grey-text">Planned: {{stopDetail?.plannedArrivalTimeOfStop }}</span>
                <span class="h8 {{calculateStopDifference(stopDetail?.plannedArrivalTimeOfStop,stopDetail?.actualArrivalTimeOfStop)}}" *ngIf="stopDetail?.actualArrivalTimeOfStop !== 0">
                    Actual: {{stopDetail?.actualArrivalTimeOfStop}}
                </span>
                <span class="h8 {{calculateStopDifference(stopDetail?.plannedArrivalTimeOfStop,stopDetail?.actualArrivalTimeOfStop)}}" *ngIf="stopDetail?.actualArrivalTimeOfStop === 0">
                    Actual: --
                </span>
            </div>
        </div>
        <img src="{{imgSrc}}assets/icons/cross-icon.svg" style="cursor: pointer;" (click)="onClosePopup()" />

    </div>
    <div class="data-show">
        <img src="{{imgSrc}}assets/icons/ic-ui-signin.svg" alt="" srcset=""><span> {{entry}}</span>
        &nbsp;
        <img src="{{imgSrc}}assets/icons/ic-nav-cancel.svg" alt="" srcset=""><span> {{noshow}}</span>
        &nbsp;
        Adhoc: <span> {{adhoc}}</span>

    </div>
    <div class="toggler d-flex">
        <div (click)="toggle('planned')"
            [ngClass]="{'activated':toggler=='planned','unactivated':toggler=='unPlannned'}"
            class="d-flex just-center align-center pointer-cursor width-50 planned"> <span>Planned Employees</span>
        </div>
        <div (click)="toggle('unPlanned')"
            [ngClass]="{'activated':toggler=='unPlanned','unactivated':toggler=='plannned'}"
            class="d-flex just-center align-center pointer-cursor width-50 unplanned"> <span>Unplanned Sign-Ins</span>
        </div>
    </div>


    <div *ngIf="toggler=='planned'" class="planned-details">

        <div *ngFor="let item of stopDetail.plannedEmployees,let i = index;" class="card d-flex just-space">
            <div class="card1 d-flex gap-8">
                <div>
                    <div [style.background-color]="colors[i % colors.length]"
                        class="employee-name-circle d-flex just-center align-center"><span class="h6-b">{{ item?.name[0]
                            }}</span></div>
                </div>
                <div class="d-flex flex-dir-col">
                    <span class="h7">{{item?.name}}</span>
                    <span *ngIf="item.gender==='Female'"><img src="{{imgSrc}}assets/icons/female_icon.svg" alt="">                    <span class="h8 grey">{{item.employeeId}}</span>
                </span>
                    <span *ngIf="item.gender==='Male'"><img src="{{imgSrc}}assets/icons/male_icon.svg" alt="">                    <span class="h8 grey">{{item.employeeId}}</span>
                </span>

                </div>
            </div>

            <div class="card2 d-flex flex-dir-col">
                <span class="h7">{{getConvertedTimeZoneTime(item?.actualPickupTime)}}</span>
                <span class="h8 grey">Signed In at</span>
            </div>

            <div class="card3">
                <span [style.color]="getShuttleStatus(item.empStatus).color" class="h8-b">
                    {{ getShuttleStatus(item.empStatus)?.name }}
                    <span class="h8 grey">Mechanism: {{item.signInSource}}</span>
                </span>
            </div>
        </div>
    </div>


    <div *ngIf="toggler=='unPlanned'" class="unplanned-details">

        <div *ngIf="stopDetail?.actualArrivalTimeOfStop != 0">
            <div *ngFor="let item of stopDetail.unplannedEmployees,let i = index;" class="card d-flex just-space">
                <div class="card1 d-flex gap-8">
                    <div>
                        <div [style.background-color]="colors[i % colors.length]"
                            class="employee-name-circle d-flex just-center align-center"><span class="h6-b">{{
                                item?.name[0] }}</span></div>
                    </div>
                    <div class="d-flex flex-dir-col">
                        <span class="h7">{{ item?.name}}</span>
                        <span class="h8 grey">{{ item.employeeId }}</span>
                    </div>
                </div>
                
                <div class="card2 d-flex flex-dir-col">
                    <span class="h7">{{getConvertedTimeZoneTime(item?.actualPickupTime)}}</span>
                    <span class="h8 grey">Signed In at</span>
                </div>

                <div class="card3">
                    <span *ngIf="getShuttleStatus(item.shuttleEmpSignInType)?.name === 'Different Sign In Location'"
                        class="h8-b" [style.color]="getShuttleStatus(item.shuttleEmpSignInType).color">
                        Different Planned Stop
                    </span>
                    <span *ngIf="getShuttleStatus(item.shuttleEmpSignInType)?.name !== 'Different Sign In Location'"
                        class="h8-b" [style.color]="getShuttleStatus(item.shuttleEmpSignInType).color">
                        {{ getShuttleStatus(item.shuttleEmpSignInType)?.name }}
                        <span class="h8 grey">Mechanism: {{item.signInSource}}</span>
                    </span>

                </div>
            </div>
        </div>

        <div class="no-employee-info" *ngIf="stopDetail?.actualArrivalTimeOfStop == 0 ">
            <img src="{{imgSrc}}assets/icons/employee-information-not-found.svg" alt="">
        </div>


    </div>



</div>





<div *ngIf="otaOtdData" class="main">
    <div *ngIf="!fromCabTripReplay" class="heading d-flex flex-dir-row just-space">
        <div class="d-flex flex-dir-col">
            <div class="d-flex just-space"><span class="h6-b">{{stopDetail?.address}}</span><img *ngIf="false"
                    class="pointer-cursor" (click)="onClosePopup()" src="{{imgSrc}}assets/icons/cross-icon.svg" alt="">
            </div>
            <div class="d-flex gap-8" >
                <span class="h8 grey-text">Planned: {{stopDetail?.plannedArrivalTimeOfStop }}</span>
                <span class="h8 {{calculateStopDifference(stopDetail?.plannedArrivalTimeOfStop,stopDetail?.actualArrivalTimeOfStop)}}" *ngIf="stopDetail?.actualArrivalTimeOfStop !== 0">
                    Actual: {{stopDetail?.actualArrivalTimeOfStop}}
                </span>
                <span class="h8 {{calculateStopDifference(stopDetail?.plannedArrivalTimeOfStop,stopDetail?.actualArrivalTimeOfStop)}}" *ngIf="stopDetail?.actualArrivalTimeOfStop === 0">
                    Actual: --
                </span>
            </div>
        </div>
        <img src="{{imgSrc}}assets/icons/cross-icon.svg" style="cursor: pointer;" (click)="onClosePopup()" />

    </div>

    <div *ngIf="fromCabTripReplay" class="heading d-flex flex-dir-row just-space">
        <div class="d-flex flex-dir-col">
            <div class="d-flex just-space"><span class="h6-b">{{tripDetails.direction === 'IN' ? tripDetails.plannedEndLocation.address : tripDetails.plannedStartLocation.address }}</span><img *ngIf="false"
                    class="pointer-cursor" (click)="onClosePopup()" src="{{imgSrc}}assets/icons/cross-icon.svg" alt="">
            </div>
            <div class="d-flex gap-8" >
                <span class="h8 grey-text">Planned {{tripDetails.direction === 'OUT' ? 'Start time ' : 'End time '}}: {{ formatDate( tripDetails.direction === 'OUT' ? tripDetails?.plannedStartTime :  tripDetails?.plannedEndTime) }}</span>
                <span class="h8 {{calculateFinalDiff(tripDetails.direction === 'OUT' ? tripDetails?.plannedStartTime :  tripDetails?.plannedEndTime, tripDetails.direction === 'OUT' ? tripDetails?.actualStartTime : tripDetails?.actualEndTime )}}" *ngIf="tripDetails?.actualEndTime !== 0">
                    Actual {{tripDetails.direction === 'OUT' ? 'Start time ' : 'End time '}}: {{  formatDate( tripDetails.direction === 'OUT' ? tripDetails?.actualStartTime : tripDetails?.actualEndTime)}}
                </span>
                <span class="h8 {{calculateFinalDiff(tripDetails?.plannedEndTime,tripDetails?.actualEndTime)}}" *ngIf="tripDetails?.actualEndTime === 0">
                    Actual: --
                </span>
            </div>
        </div>
        <img src="{{imgSrc}}assets/icons/cross-icon.svg" style="cursor: pointer;" (click)="onClosePopup()" />

    </div>
    <div class="data-show">
        <span class="d-flex align-center gap-4">
            <img src="{{imgSrc}}assets/icons/ic-ui-signin.svg" alt="" srcset=""><span> {{entry}}</span>
        </span>
        <span class="d-flex align-center gap-4">
            <img src="{{imgSrc}}assets/icons/ic-nav-cancel.svg" alt="" srcset=""><span> {{noshow}}</span>
        </span>
        <span class="d-flex align-center gap-4">
            Adhoc: <span> {{adhoc}}</span>
        </span>

    </div>


    <div *ngIf="otaOtdData " class="ota-otd">
        <!-- Clickable Header -->
        <p class="delayed-header" 
            [ngClass]="{ 'early-text': !tripDelayDetails || tripDelayDetails?.DELAY_MINS === 0, 'delayed-text': tripDelayDetails && tripDelayDetails?.DELAY_MINS > 0 }"
            (click)="toggleExpandCollapse()">
            {{ getDelayMessage(tripDelayDetails) }}
    
            <!-- Arrow icon -->
            <span *ngIf=" tripDelayDetails&&tripDelayDetails?.DELAY_MINS !== 0"  class="arrow-icon" [ngClass]="{ 'rotate': isExpanded }">
                <img src="{{imgSrc}}assets/icons/line-down-arrow.svg" alt="">
            </span>
        </p>
    
        <!-- Expandable Section with Animation -->
        <div *ngIf="isExpanded && tripDelayDetails?.DELAY_MINS !== 0" class="expandable-content" @slideInOut>
            <div class="trip-delay-grace-time">
                <span class="delay-property-label">Trip Delay Grace : </span>
                <span *ngIf="tripDelayDetails.TRIP_DIRECTION === 'IN'; else outDirection" class="delay-property-value">
                    {{tripDelayDetails.TRIP_DELAY_LOGIN_GRACE_SECS}} sec(s)
                  </span>
                  <ng-template #outDirection>
                    <span class="delay-property-value">  {{tripDelayDetails.TRIP_DELAY_LOGOUT_GRACE_SECS}} sec(s)</span>
                  </ng-template>
                </div>
    
            <div class="separator"></div>

            <!-- Delay Details -->
             
            <ng-container *ngIf="tripDelayDetails.DELAY_TYPE == 'EMPLOYEE'">
                <div class="delay-detailed-section">
                    <div class="delay-main-header">Employee has delayed</div>
                    <div class="main-reason">
                        <p>{{tripDelayDetails.DELAY_REASON}} </p>
                    </div>
                    <div class="actual-sign-in-time">
                        <span class="delay-property-label">Actual Sign-In Time of  {{ tripDelayDetails.EMPLOYEE.EMPLOYEE_NAME }}( {{tripDelayDetails.EMPLOYEE.EMPLOYEE_ID }}) : </span>
                        <span class="delay-property-value">{{ tripDelayDetails.EMPLOYEE?.ACTUAL_SIGN_IN_TIME |date: 'HH:mm | dd MMM yyyy' }}</span>
                    </div>
                    <div class="planned-sign-in-time">
                        <span class="delay-property-label">Planned Sign-In Time of {{ tripDelayDetails.EMPLOYEE.EMPLOYEE_NAME }}( {{tripDelayDetails.EMPLOYEE.EMPLOYEE_ID }}) : </span>
                        <span class="delay-property-value">{{ tripDelayDetails.EMPLOYEE?.PLANNED_SIGN_IN_TIME | date: 'HH:mm | dd MMM yyyy' }}</span>
                    </div>
                </div>
            </ng-container>
    
            <!-- Driver Delay Section -->
            <ng-container *ngIf="tripDelayDetails.DELAY_TYPE == 'DRIVER'">
                <div class="delay-detailed-section">
                    <div class="delay-main-header">Driver has delayed</div>
                    <div class="main-reason">
                        <p>{{tripDelayDetails.DELAY_REASON}} </p>

                    </div>
                    <div class="actual-sign-in-time">
                        <span class="delay-property-label">Driver Reporting Time : </span>
                        <span class="delay-property-value">{{ tripDelayDetails.DRIVER?.DRIVER_REPORTING_TIME | date: 'HH:mm | dd MMM yyyy' }}</span>
                    </div>
                    <div class="planned-sign-in-time">
                        <span class="delay-property-label">Planned Sign-In Time : </span>
                        <span class="delay-property-value">{{ tripDelayDetails.DRIVER?.PLANNED_PICKUP_TIME | date: 'HH:mm | dd MMM yyyy' }}</span>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="tripDelayDetails.DELAY_TYPE == 'TRAFFIC'">
                <div class="delay-detailed-section">
                    <div class="delay-main-header"> Delayed Due to Traffic</div>
                <div class="main-reason"> The driver reported on time as well as the employee signed in on time but the trip got delayed due to Traffic </div>
                    </div>
            </ng-container>
            <!-- Employee Grace Time For OTA -->
                 <div *ngIf=" tripDetails.direction === 'IN'" class="employee-grace-time">
                <span class="delay-property-label">Employee Grace Time: </span>
                <span class="delay-property-value">{{ tripDelayDetails?.EMPLOYEE_GRACE_TIME_MIN }} min(s)</span>
                </div>                      
            
        </div>
    </div>
    
    
    <div class="toggler d-flex">
        <div (click)="toggle('planned')"
            [ngClass]="{'activated':toggler=='planned','unactivated':toggler=='unPlannned'}"
            class="d-flex just-center align-center pointer-cursor width-50 planned"> <span> Planned sign-ins</span>
        </div>
        <div (click)="toggle('unPlanned')"
            [ngClass]="{'activated':toggler=='unPlanned','unactivated':toggler=='plannned'}"
            class="d-flex just-center align-center pointer-cursor width-50 unplanned"> <span>Adhoc sign-ins</span>
        </div>
    </div>

    <div *ngIf="toggler=='planned' && fromCabTripReplay" class="planned-details">

        <div *ngFor="let item of plannedSignIns,let i = index;" class="card d-flex just-space">
            <div class="card1 d-flex gap-8">
                <div>
                    <div [style.background-color]="colors[i % colors.length]"
                        class="employee-name-circle d-flex just-center align-center">
                        <span class="h6-b"> {{ item?.name[0] }} </span>
                    </div>
                </div>
                <div class="d-flex flex-dir-col">
                    <span class="h7 truncate max-w-100" [title]="item?.name" > {{item?.name}} </span>
                    <span *ngIf="item.gender==='Female'" class="d-flex align-center gap-8">
                        <img src="{{imgSrc}}assets/icons/female_icon.svg" alt="">
                        <span class="h8 grey"> {{item.employeeId}} </span>
                    </span>
                    <span *ngIf="item.gender==='Male'" class="d-flex align-center gap-8">
                        <img src="{{imgSrc}}assets/icons/male_icon.svg" alt="">
                        <span class="h8 grey"> {{item.employeeId}} </span>
                    </span>

                </div>
            </div>
            <div class="card2 d-flex d-flex-col" style="width: 200px;">
                <div>
                    <span class="h8 grey">Signed In at : </span> <span class="h7">{{getConvertedTimeZoneTime(item?.actualPickupTime)}}</span>
                </div>
                <div>
                    <span class="h8 grey">Signed Off at : </span> <span class="h7">{{getConvertedTimeZoneTime(item.actualDropTime)}}</span>
                </div>
            </div>


            <div class="card3 d-flex d-flex-col" style="width: 200px;">
                <div>
                    <span class="h8 grey">Signed In Via : {{item.signInSource  ?? '--'}}</span>
                  
                </div>
                <div>
                    <span class="h8 grey">Signed Off Via : {{item.signOffSource  ?? '--'}}</span>
                </div>
            </div>

            <div class="card2 d-flex align-center" style="width: 132px;">
                <span class="h8 grey">DRT : </span>
                <span class="h7">{{getConvertedTimeZoneTime(item?.actualPickupTime)}}</span>
            </div>
        </div>
        <div class="no-emp-found" *ngIf="!plannedSignIns.length">
            <p>No Planned-sign in's present</p>
        </div>
    </div>

    <div *ngIf="toggler=='unPlanned'  && fromCabTripReplay" class="unplanned-details">

        <div *ngFor="let item of adhocSignIns,let i = index;" class="card d-flex just-space">
            <div class="card1 d-flex gap-8">
                <div>
                    <div [style.background-color]="colors[i % colors.length]"
                        class="employee-name-circle d-flex just-center align-center">
                        <span class="h6-b"> {{ item?.name[0] }} </span>
                    </div>
                </div>
                <div class="d-flex flex-dir-col">
                    <span class="h7 truncate max-w-100" [title]="item?.name" > {{item?.name}} </span>
                    <span *ngIf="item.gender==='Female'" class="d-flex align-center gap-8">
                        <img src="{{imgSrc}}assets/icons/female_icon.svg" alt="">
                        <span class="h8 grey"> {{item.employeeId}} </span>
                    </span>
                    <span *ngIf="item.gender==='Male'" class="d-flex align-center gap-8">
                        <img src="{{imgSrc}}assets/icons/male_icon.svg" alt="">
                        <span class="h8 grey"> {{item.employeeId}} </span>
                    </span>

                </div>
            </div>
            <div class="card2 d-flex d-flex-col" style="width: 200px;">
                <div>
                    <span class="h8 grey">Signed In at : </span> <span class="h7">{{getConvertedTimeZoneTime(item?.actualPickupTime)}}</span>
                </div>
                <div>
                    <span class="h8 grey">Signed Off at : </span> <span class="h7">{{getConvertedTimeZoneTime(item.actualDropTime)}}</span>
                </div>
            </div>


            <div class="card3 d-flex d-flex-col" style="width: 200px;">
                <div>
                    <span class="h8 grey">Signed In Via : {{item.signInSource ?? '--'}}</span>
                  
                </div>
                <div>
                    <span class="h8 grey">Signed Off Via : {{item.signOffSource  ?? '--'}}</span>
                </div>
            </div>
        </div>
        <div class="no-emp-found" *ngIf="!adhocSignIns.length">
            <p>No Adhoc-sign in's present</p>
        </div>

    </div>


    <div *ngIf="toggler=='planned'  && !fromCabTripReplay" class="planned-details ">

        <div *ngFor="let item of employeesList,let i = index;" class="card d-flex just-space employee-list-container">
            <div class="card1 d-flex gap-8 flex-1">
                <div>
                    <div [style.background-color]="colors[i % colors.length]"
                        class="employee-name-circle d-flex just-center align-center"><span class="h6-b">{{ item?.name[0]
                            }}</span></div>
                </div>
                <div class="d-flex flex-dir-col" >
                    <span class="h7">{{item?.name}}</span>
                    <span class="data-show" *ngIf="item.gender==='Female'"><img src="{{imgSrc}}assets/icons/female_icon.svg" alt="">                    
                        <span class="h8 grey">{{item.employeeId}}</span>
                </span>
                    <span class="data-show" *ngIf="item.gender==='Male'"><img src="{{imgSrc}}assets/icons/male_icon.svg" alt="">                    
                        <span class="h8 grey">{{item.employeeId}}</span>
                </span>

                </div>
            </div>

            <div class="card2 d-flex flex-dir-col flex-1">
                <span class="h7">{{getConvertedTimeZoneTime(item?.actualPickupTime)}}</span>
                <span class="h8 grey">Signed Off at</span>
            </div>

            <div class="card3 flex-1">
                <span [style.color]="getShuttleStatus(item.shuttleEmpSignInType).color" class="h8-b">
                    {{ getShuttleStatus(item.shuttleEmpSignInType)?.name }}
                </span>
                <span class="h8 grey">Mechanism: {{item.signOffSource}}</span>
            </div>
        </div>
    </div>

    <div *ngIf="toggler=='unPlanned'  && !fromCabTripReplay" class="unplanned-details">

        <div *ngIf="stopDetail?.actualArrivalTimeOfStop != 0">
            <div *ngFor="let item of stopDetail.unplannedEmployees,let i = index;" class="card d-flex just-space">
                <div class="card1 d-flex gap-8">
                    <div>
                        <div [style.background-color]="colors[i % colors.length]"
                            class="employee-name-circle d-flex just-center align-center"><span class="h6-b">{{
                                item?.name[0] }}</span></div>
                    </div>
                    <div class="d-flex flex-dir-col">
                        <span class="h7">{{ item?.name}}</span>
                        <span class="h8 grey">{{ item.employeeId }}</span>
                    </div>
                </div>
                
                <div class="card2 d-flex flex-dir-col">
                    <span class="h7">{{getConvertedTimeZoneTime(item?.actualPickupTime)}}</span>
                    <span class="h8 grey">Signed In at</span>
                </div>
                <div class="card3">
                    <span *ngIf="getShuttleStatus(item.shuttleEmpSignInType)?.name === 'Different Sign In Location'"
                        class="h8-b" [style.color]="getShuttleStatus(item.shuttleEmpSignInType).color">
                        Different Planned Stop
                    </span>
                    <span *ngIf="getShuttleStatus(item.shuttleEmpSignInType)?.name !== 'Different Sign In Location'"
                        class="h8-b" [style.color]="getShuttleStatus(item.shuttleEmpSignInType).color">
                        {{ getShuttleStatus(item.shuttleEmpSignInType)?.name }}              
                    </span>
                    <span class="h8 grey">Mechanism: {{item.signOffSource}}</span>

                </div>
            </div>
        </div>

        <div class="no-employee-info" *ngIf="stopDetail?.actualArrivalTimeOfStop == 0 ">
            <img src="{{imgSrc}}assets/icons/employee-information-not-found.svg" alt="">
        </div>


    </div>



</div>